<div class="container-fluid">
  <!-- Header-->
  <header>
    <div class="row ey-header-container">
      <div class="col-sm-12">
        <h1 class="ey-header">Page Not Found</h1>
      </div>
    </div>
  </header>
  <!-- Header-->

  <!--Content-->
  <div class="ey-content mt-3">
    <div class="col-sm-12">
      <p class="text-danger">Sorry, we could not find the page you requested.</p>
    </div>
  </div>
  <!--Content-->
</div>
